export const actions = {
  set: 'SET::USER'
}

export default actions



// WEBPACK FOOTER //
// ./src/store/user/actions.js